// extracted by mini-css-extract-plugin
module.exports = {"heading":"MobileTermsOfServicePage_heading__2iDsJ","content":"MobileTermsOfServicePage_content__1Tz_d"};